import './TasksMenuTile.style.less'
import * as React from 'react'
// import cx from 'classnames'
// import { isDark } from '@/utils/darkmode'
import { Doughnut } from 'react-chartjs-2'

interface Props {
  title: string | React.ReactNode
  qty: string
  isActive?: boolean
  icon?: React.ReactNode
  color: string
  isProgress?: boolean
  isSelected?: boolean
  data?: number[]
  onClick?: () => any
}

function TasksMenuTile(props: Props) {
  const { isProgress = false, data, onClick, isSelected = false } = props
  const { title, qty, icon, color } = props
  const [plugins, setPlugins] = React.useState<any>()

  React.useLayoutEffect(() => {
    const plugins = [
      {
        id: 'activeOrders',
        afterDraw: function (chart) {
          const {
            ctx,
            chartArea: { width, height },
          } = chart
          ctx.save()

          const label = chart.config.data.datasets[0].label

          ctx.font = '16px sans-serif'
          ctx.textAlign = 'center'
          ctx.textStyle = '#5B5B5B'
          ctx.fontWeight = 'bold'
          ctx.fillText(label, width / 2, height / 2 + 14 * 0.34)
        },
      },
    ]

    setPlugins(plugins)
  }, [qty])

  if (isProgress) {
    return (
      <div
        className="task-tile-menu-container"
        style={{
          color,
          cursor: 'pointer',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        onClick={onClick}
      >
        <div className="task-landing-page-tile-icon">
          {qty && (
            <div style={{ width: 60, height: 60, marginLeft: 16 }}>
              <Doughnut
                data={{
                  labels: ['Urgent', 'Warning', 'On-track'],
                  datasets: [
                    {
                      label: qty,
                      data,
                      backgroundColor: [
                        '#C03261',
                        '#EF9747',
                        '#4A8DC0',
                        '#848484',
                      ],
                      borderWidth: 0,
                    },
                  ],
                }}
                plugins={plugins}
                options={{
                  plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false },
                    datalabels: null,
                  },
                  cutout: '70%',
                  hover: { mode: null },
                }}
              />
            </div>
          )}
        </div>
        <div className="task-landing-page-tile-container">
          <div className="task-landing-page-tile-title">{title}</div>
        </div>
      </div>
    )
  }
  const classBackground = !isSelected
    ? 'task-tile-menu-container'
    : 'task-tile-menu-container selected-tile'
  return (
    <div
      className={classBackground}
      onClick={onClick}
      style={{ color, cursor: onClick && 'pointer' }}
    >
      {icon && <div className="task-landing-page-tile-icon">{icon}</div>}

      <div className="task-landing-page-tile-container">
        <div className="task-landing-page-tile-title">{title}</div>
        <div className="task-landing-page-tile-qty">{qty}</div>
      </div>
    </div>
  )
}

export default TasksMenuTile
